import { Box, ThemeProvider, Typography } from '@mui/material';
import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { setupLogoutMechanism } from '../../../Screens/menu_planner/AxiosInstance';
import { menuPlannerTheme } from '../../../utils/MenuPlannerTheme';
import classes from './PlannerHeader.module.css';
import LanguageSwitch from '../../../Screens/menu_planner/components/LanguageSwitch';
import { useDispatch, useSelector } from 'react-redux';
import ProfileMenu from './ProfileMenu';
import CalendarMenu from './CalendarMenu';
import { Helmet } from 'react-helmet';
import CanteenSelectorMenu from './CanteenSelectorMenu';
import { useTranslation } from 'react-i18next';

const PlannerHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navStyle = ({ isActive }) =>
    isActive ? classes.navActive : classes.navStyle;
  const { user, token } = useSelector((state) => state.auth);
  const isSuperAdmin = user?.roles?.includes('SuperAdmin');
  const hasSelectedCanteen = Boolean(user?.canteen?.id);
  const shouldRenderPlannerContent =
    token === null || !isSuperAdmin || hasSelectedCanteen;

  const dispatch = useDispatch();
  setupLogoutMechanism(navigate, dispatch);

  return (
    <ThemeProvider theme={menuPlannerTheme}>
      <Helmet>
        <title>FoodFe Meal Planner</title>
      </Helmet>
      <Box>
        <div
          className={`${classes.headerContainer} ${classes.headerContainerBgColor}`}
        >
          <div className={classes.headerLogoAndTitle}>
            <img
              className='logo-img'
              src={process.env.PUBLIC_URL + '/assets/logo.svg'}
              alt='logo'
            />
            <Typography
              component='span'
              variant='s18_w600'
              className={classes.title}
              lineHeight='300%'
            >
              Menu Planner
            </Typography>
          </div>

          {token !== null ? (
            <div className={classes.headerNavigationSection}>
              {isSuperAdmin ? (
                <div className={classes.canteenSelector}>
                  <CanteenSelectorMenu />
                </div>
              ) : null}
              <div className={classes.navHolder}>
                {/* <NavLink to='dashboard' className={navStyle}>
                  <Typography variant='s16_w600'>Dashboard</Typography>
                </NavLink> */}

                <NavLink to='food-boxes' className={navStyle}>
                  <Typography variant='s16_w600'>Food Boxes</Typography>
                </NavLink>

                <NavLink to='schedules' className={navStyle}>
                  <Typography variant='s16_w600'>Schedules</Typography>
                </NavLink>

                <CalendarMenu mealsPlan={user?.canteen?.mealPlans} />
                <LanguageSwitch />
                <NavLink to='notification' className={navStyle}>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      '/assets/menu_planner/notification-bell.svg'
                    }
                    alt='Notification'
                    className={classes.headerIcon}
                  />
                </NavLink>
                <ProfileMenu />
              </div>
            </div>
          ) : null}
        </div>
        <Box className={classes.childContainer}>
          {shouldRenderPlannerContent ? (
            <Outlet />
          ) : (
            <Box
              className='content-horizontal-margin'
              sx={{
                mt: 4,
                p: 4,
                border: '1px solid #E5E5E5',
                borderRadius: '8px',
                backgroundColor: '#FFFFFF',
              }}
            >
              <Typography variant='s18_w600'>{t('Select canteen')}</Typography>
              <Typography variant='s16_w500' mt={1}>
                {t('Please select a canteen to continue.')}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default PlannerHeader;
